import { OnSchedRest }          from '../../../OnSchedRest'
import { OnSchedWizardHelpers } from '../OnSchedWizardHelpers'
import { OnSchedHelpers }       from '../../OnSchedHelpers'
import { OnSchedTemplates } from '../../../OnSchedTemplates';


export const InitResourceDomElements = (element, data) => {
  // wire up events for the file upload button

  const elSystemFileUploadBtn = document.querySelector(".onsched-wizard.onsched-form input[name=onsched-system-file-upload]");
  elSystemFileUploadBtn.addEventListener("change", function(event) {
      const elFileUploadTxt = document.querySelector(".onsched-wizard.onsched-form .onsched-file-upload-txt");
      if (elSystemFileUploadBtn.value) {
          var uploadedFileName = elSystemFileUploadBtn.value.match( /[\/\\]([\w\d\s\.\-\(\)]+)$/ )[0];
          uploadedFileName = uploadedFileName.replace(/^\\|\\$/g, ''); // remove leading backslash
          elFileUploadTxt.innerHTML = uploadedFileName;
          elFileUploadTxt.dataset.uploadedImage = true;
          var image = document.getElementById("onsched-image-preview");
          image.src = URL.createObjectURL(event.target.files[0]);
          const base64String = OnSchedWizardHelpers.Base64Encoded(image); 
          // save the filename so we can POST the uploadimage later
          elSystemFileUploadBtn.dataset.filename = uploadedFileName;
      }
      else {
          elFileUploadTxt.innerHTML = "No file chosen, yet.";
          elFileUploadTxt.dataset.uploadedImage = false;
      }
  });

  const elFileUploadBtn = document.querySelector(".onsched-wizard.onsched-form .onsched-file-upload-btn");
  elFileUploadBtn.addEventListener("click", function(event) {
      elSystemFileUploadBtn.click();
  });

  const elSyncMsg = document.getElementById('onsched-calendar-sync-message');
  const calendarProviders = { 0: 'OnSched', 1: 'Google', 2: 'Outlook' };

  var calendarSync = { 
      id: '',
      authorized: false,
      provider: calendarProviders[data.calendarAvailability ? data.calendarAvailability : 0],
    };

  if (data.googleCalendarAuthorized) {
      calendarSync.authorized = true;
      calendarSync.id = data['googleCalendarId'];
    }
  else if (data.outlookCalendarAuthorized) {
      calendarSync.authorized = true;
      calendarSync.id = data['outlookCalendarId'];
  }

  if (calendarSync.authorized) {
    let icon = `<i class="calendarSync-icon fab fa-${parseInt(calendarSync.provider) === 1 ? 'google' : 'windows'}"></i>`;
      elSyncMsg.innerHTML = `The calendar associated with ${calendarSync.id} is authorized. <span id="onsched-calendar-provider">${icon} ${calendarSync.provider} Calendar</span> will be used for availability`
    }
    else {
      elSyncMsg.innerHTML = `OnSched Calendar will be used for availability`
  }

  const elCalAvailability = document.getElementById('calendarAvailability');
  const elExternalId = document.getElementById('externalCalendarId');

  elCalAvailability.onchange = e => {
    if (parseInt(e.target.value) < 1) {
        elExternalId.required = false;
        elSyncMsg.innerHTML = 'OnSched Calendar will be used for availability'
    }
    else {
        elExternalId.required = true;
        let icon = `<i class="calendarSync-icon fab fa-${parseInt(e.target.value) === 1 ? 'google' : 'windows'}"></i>`;

        if (elExternalId.value.length) {
            elSyncMsg.innerHTML = `${elExternalId.value} will attempt to authorize with <span id="onsched-calendar-provider">${icon} ${calendarProviders[parseInt(e.target.value)]} Calendar</span> for availability`
        }
        else {
            elSyncMsg.innerHTML = `Please enter an External Calendar Email to authorize with <span id="onsched-calendar-provider">${icon} ${calendarProviders[parseInt(e.target.value)]} Calendar</span>`
        }         
    }
  }

  elExternalId.onkeyup = e => {
      if (parseInt(elCalAvailability.value) < 1) {
        elSyncMsg.innerHTML = 'OnSched Calendar will be used for availability'
      }
      else {
        let icon = `<i class="calendarSync-icon fab fa-${parseInt(elCalAvailability.value) === 1 ? 'google' : 'windows'}"></i>`;
        
        if (e.target.value.length) {
            elSyncMsg.innerHTML = `${e.target.value} will attempt to authorize with <span id="onsched-calendar-provider">${icon} ${calendarProviders[parseInt(elCalAvailability.value)]} Calendar</span> for availability`
        }
        else {
            elSyncMsg.innerHTML = `Please enter an External Calendar Email to authorize with <span id="onsched-calendar-provider">${icon} ${calendarProviders[parseInt(elCalAvailability.value)]} Calendar</span>`
        }
      }
  }

  // make a rest call to populate the resourceGroup select on the form
  var locationId = element.params.locationId == undefined ? "" : locationId; 
  var urlResourceGroups = element.onsched.setupApiBaseUrl + "/resourcegroups";
  urlResourceGroups = OnSchedHelpers.AddUrlParam(urlResourceGroups, "locationId", locationId);

    OnSchedRest.Get(urlResourceGroups, function (response) {
        if (response.error) {
            OnSchedHelpers.ThrowError(element, response);
        }
        else {
            var elResourceGroups = document.querySelector(".onsched-wizard.onsched-form select[name=groupId]");
            elResourceGroups.innerHTML = OnSchedTemplates.resourceGroupOptions(response.data);
            // template the resourcegroup select
        }
    }) // end rest response

    InitBlocksAllocations(element, data, 'blocks');
    InitBlocksAllocations(element, data, 'allocations');
}

const InitBlocksAllocations = (element, data, object) => {
    if (element.options[object]) {
        var elBlockRepeatObj = document.getElementById(`${object}-repeat-object`);
        var elBlockRepeats = document.getElementById(`${object}-repeats`);
        var elBlockFrequency = document.getElementById(`${object}-frequency`);
        var blockWeekdayInputs = document.querySelectorAll(`input[id^='${object}-repeat-weekly-']`);
        var elBlockWeekdays = document.getElementById(`${object}-weekdays`);
        var elBlockWeekdaysRow = document.getElementById(`${object}-weekdays-row`);
        var elBlockDWMSwitch = document.getElementById(`${object}-dwm-switch`);
        var blockWeekdays = elBlockWeekdays.value.split("");

        elBlockFrequency.onchange = e => {
            switch(e.target.value) {
                case 'D':
                    elBlockWeekdaysRow.style.display = 'none';
                    elBlockDWMSwitch.innerText = 'day(s)';
                    break;
                case 'W':
                    elBlockWeekdaysRow.style.display = 'flex';
                    elBlockDWMSwitch.innerText = 'week(s)';
                break;
                case 'M':
                    elBlockWeekdaysRow.style.display = 'none';
                    elBlockDWMSwitch.innerText = 'month(s)';
                    break;
                default:
            }
        }

        Array.from(blockWeekdayInputs).map((input, i) => input.onchange = e => {
            e.target.parentElement.className = e.target.checked ? 'selected onsched-radio' : 'onsched-radio';
            let idx = i.toString();
            
            if (blockWeekdays.includes(idx)) {
                blockWeekdays = blockWeekdays.filter(w => w !== idx);
            }
            else {
                blockWeekdays.push(idx);
            }
            
            elBlockWeekdays.value = blockWeekdays.join("");
        })


        elBlockRepeats.onchange = e => {
            if (e.target.checked) {
                elBlockRepeatObj.style.display = 'unset';
            }
            else {
                elBlockRepeatObj.style.display = 'none';
            }
        }

        const elForeverBtn = document.getElementById(`${object}-repeats-forever`);
    
        elForeverBtn.onclick = () => {
            const elEndDate = document.getElementById(`${object}-endDate`);
            
            if (elEndDate.value.slice(0, 4) === '9999') {
                elEndDate.value = document.getElementById(`${object}-startDate`).value;
            }
            else {
                elEndDate.value = '9999-01-01';
            }
        }
    
        const elBlockedTimesList = document.getElementById(`onsched-resource-${object}-list`);
        let blockTimes = [];
    
        if (element.params.id) {
            const loadBlockedTimesList = () => {
                new Promise(resolve => {
                    if (element.params.id) {
                        const resourceBlocksUrl = element.onsched.setupApiBaseUrl + '/resources/' + element.params.id + `/${object}`;
            
                        OnSchedRest.Get(resourceBlocksUrl, resourceBlocksResp => {
                            resolve(resourceBlocksResp.data)
                        })
                    }
                    else {
                        resolve(null)
                    }
                })
                .then(blocks => {
                    blocks.sort(function(a, b){return new Date(a.startDate) - new Date(b.startDate)});
        
                    if (blocks?.length) {
                        elBlockedTimesList.innerHTML = OnSchedTemplates.resourceBlockedTimesList(blocks);
                    }
                    else {
                        elBlockedTimesList.innerHTML = `<tr><td>No allocations created</td></tr>`;
                    }
            
                    document.querySelectorAll(`[data-delete="resource-${object.slice(0, -1)}"]`)
                        .forEach(deleteBlockAction => {
                            deleteBlockAction.onclick = () => {
                                const deleteResourceBlockUrl = element.onsched.setupApiBaseUrl + `/resources/${object === 'blocks' ? 'block' : 'allocations'}/` + deleteBlockAction.dataset.id;
                                OnSchedRest.Delete(deleteResourceBlockUrl, () => {
                                    loadBlockedTimesList();
                                })
                            }
                        })
                })
            }
        
            const elBlockedTimesAddBtn = document.getElementById(`onsched-resource-${object}-add-${object.slice(0, -1)}`);
        
            elBlockedTimesAddBtn.onclick = () => {
                let blockTimePayload = {
                    "id": `${new Date().getTime()}`,
                    "locationId": OnSchedHelpers.IsEmpty(data.locationId) ? '' : data.locationId,
                    "object": `resource${object.charAt(0).toUpperCase() + object.slice(1, -1)}`,
                    "startDate":"",
                    "endDate":"",
                    "startTime":"",
                    "endTime":"",
                    "reason":"",
                    "repeats":false,
                    "repeat":{
                        "frequency":"D",
                        "interval":1,
                        "weekdays":"",
                        "monthDay":"1",
                        "monthType":"D"
                    }
                }
                if (element.params.id) {
                    const resourceBlockUrl = element.onsched.setupApiBaseUrl + '/resources/' + element.params.id + `/${object === 'blocks' ? 'block' : 'allocations'}`;
        
                    document.querySelectorAll(`[data-create="resource-${object.slice(0, -1)}"]`)
                        .forEach(resourceBlockInput => {
                            blockTimePayload[resourceBlockInput.name.slice(object.length + 1)] = resourceBlockInput.dataset.type === "bool" ? resourceBlockInput.checked : resourceBlockInput.value;
                        })
                    
                    
                    if (blockTimePayload.repeats) {
                        document.querySelectorAll(`[data-create="resource-${object.slice(0, -1)}.repeat"]`)
                            .forEach(repeatInput => {
                                blockTimePayload.repeat[repeatInput.name] = repeatInput.dataset.type === "bool" ? repeatInput.checked : repeatInput.value;
                            })
                    }
        
                    blockTimePayload.repeat.monthDay = parseInt(document.getElementById(`${object}-startDate`).value.slice(-2));

                    delete blockTimePayload.id;
        
                    OnSchedRest.Post(resourceBlockUrl, blockTimePayload, blockTimeResp => {
                        if (blockTimeResp.error) {
                            OnSchedHelpers.ThrowError(element, blockTimeResp);
                        }
                        else {
                            loadBlockedTimesList();
                        }
                    })
                }
            }
        
            loadBlockedTimesList();
        }
        else {
            const loadBlockedTimesList = () => {
                if (blockTimes?.length) {
                    elBlockedTimesList.innerHTML = OnSchedTemplates.resourceBlockedTimesList(blockTimes);
                }
                else {
                    elBlockedTimesList.innerHTML = `<tr><td>No ${object} created.</td></tr>`;
                }
        
                document.querySelectorAll(`[data-delete="resource-${object.slice(0, -1)}"]`)
                    .forEach(deleteBlockAction => {
                        deleteBlockAction.onclick = () => {
                            blockTimes = blockTimes.filter(a => a.id !== deleteBlockAction.dataset.id);
    
                            loadBlockedTimesList();
                        }
                    })
            }
            
            const elBlockedTimesAddBtn = document.getElementById(`onsched-resource-${object}-add-${object.slice(0, -1)}`);
        
            elBlockedTimesAddBtn.onclick = () => {
                let blockTimePayload = {
                    "id": `${new Date().getTime()}`,
                    "locationId": OnSchedHelpers.IsEmpty(data.locationId) ? '' : data.locationId,
                    "object": `resource${object.charAt(0).toUpperCase() + object.slice(1, -1)}`,
                    "startDate":"",
                    "endDate":"",
                    "startTime":"",
                    "endTime":"",
                    "reason":"",
                    "repeats":false,
                    "repeat":{
                        "frequency":"D",
                        "interval":1,
                        "weekdays":"",
                        "monthDay":"1",
                        "monthType":"D"
                    }
                }
                document.querySelectorAll(`[data-create="resource-${object.slice(0, -1)}"]`)
                    .forEach(resourceBlockInput => {
                        // console.log(resourceBlockInput)
                        blockTimePayload.id = new Date().getTime().toString();
                        blockTimePayload[resourceBlockInput.name.slice(object.length + 1)] = resourceBlockInput.dataset.type === "bool" ? resourceBlockInput.checked : resourceBlockInput.value;
                    })
                
                
                if (blockTimePayload.repeats) {
                    document.querySelectorAll(`[data-create="resource-${object.slice(0, -1)}.repeat"]`)
                        .forEach(repeatInput => {
                            blockTimePayload.repeat[repeatInput.name] = repeatInput.dataset.type === "bool" ? repeatInput.checked : repeatInput.value;
                        })
                }
    
                blockTimePayload.repeat.monthDay = parseInt(document.getElementById(`${object}-startDate`).value.slice(-2));

                console.log('before push', blockTimes.length, blockTimes)
                blockTimes.push(blockTimePayload);
                console.log('after push', blockTimes.length, blockTimes)
                loadBlockedTimesList();
            }
        
            loadBlockedTimesList();
        }
    }   
}